import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,  MDBRow, MDBCol, Link   } from 'mdbreact';
import { MDBBreadcrumb, MDBBreadcrumbItem } from "mdbreact";
import {  MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink } from "mdbreact";
import Axios from 'axios'
import { Steps, Alert, Form,Select,Button, Input,Avatar, Badge  } from 'antd';
import Modalarticlefaculty from './Modalarticlefaculty';
import Modalsentedit from './Modalsentedit';
import Modalsuccess from './Modalsuccess';
import axios from 'axios';

import { Table,   Space } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined ,RightCircleOutlined} from '@ant-design/icons';
import Loading from './Loading';
import Leftmenu from './Leftmenu';


const { Option } = Select;

export default class adminfacultyi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Loading: false,
        article2:[],
        curriculamlist: [],
        emp:[],
        activeItem: "1",
        admin_faculty:"",
        search1:"",
        search2:"",
        search3:"",
        filteredInfo: null,
        sortedInfo: null,
        coursenosent:[],
        empidsent:"",
    };
    this.onChangeSelect = this.onChangeSelect.bind(this)
    this.Search = this.Search.bind(this);
    //  this.selectatf = this.selectatf.bind(this);
     this.handleChange = this.handleChange.bind(this);
     this.Searchcoursenosent = this.Searchcoursenosent.bind(this);
     this.Searchcoursenosentlist = this.Searchcoursenosentlist.bind(this);
    // this.updateat = this.updateat.bind(this);
  }

    onChangeSelect = value => event => {
        this.setState({
          [value]: event
      })
    }


   Search(event) {
      this.setState({ Loading: true })
      axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/listsentgradei/ShowListCourseTerm/'+this.state.emp[0].citizen_id+'/'+this.state.search1+'/'+this.state.search2+'/'+this.state.search3)
          .then(res => {
              this.setState({
                  curriculamlist: res.data.DetailListTeacherKi
                  ,Loading: false
              })
          })
  }

  Searchcoursenosent() {
    this.setState({ Loading: true })
    axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/gradei/ListTermPrintGrade/'+this.state.empidsent)
        .then(res => {
            this.setState({
                coursenosent: res.data
                ,Loading: false
            })
        })
        console.log(this.state.empidsent)
 }

 Searchcoursenosentlist=(a,b)=> {
  // this.setState({ Loading: true })
  // axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/grade/ListTermPrintGrade/'+this.state.empidsent)
  //     .then(res => {
  //         this.setState({
  //             coursenosent: res.data
  //             ,Loading: false
  //         })
  //     })
  const bb = b.substring(0, 1)
  const bb2 = b.substring(2, 6)
       console.log(a)
       console.log(bb)
       console.log(bb2)

       this.setState({
        search1: a
        ,search2: bb
        ,search3: bb2
    })

    this.setState({ Loading: true })
    axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/listsentgrade/ShowListCourseTerm/'+this.state.emp[0].citizen_id+'/'+a+'/'+bb+'/'+bb2)
        .then(res => {
            this.setState({
                curriculamlist: res.data.DetailListTeacherKi
                ,Loading: false
            })
        })

     
}

  
  handleChange = (pagination, filters, sorter) => {
    console.log('Various parameters', pagination, filters, sorter);
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  };

  componentDidMount() {

    // const token = JSON.parse(localStorage.getItem('nameuser'));
    if (localStorage.getItem('type2') == null) {
        window.location.href = 'https://e-student.kpru.ac.th/grade/'
    } else {
       // this.setState({ admin_faculty:localStorage.getItem('admin_faculty')})
    }

    // axios.get(`https://kpruinnovation.kpru.ac.th/api/teacher/SelectTeacherreport`,
    // {headers: {
    //     //Authorization: 'Bearer ' + localStorage.getItem('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MTQ5MzgzMjgsImV4cCI6MTYxNTE1NDMyOCwidXNlcmlkIjpudWxsfQ.nmTzf07-cu1RaUZjW4QvdU5gy_9pqbwBtfm7J76J88A')
    //     Authorization: 'Bearer  eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MTQ5Mzg1ODAsImV4cCI6MTYxNTE1NDU4MCwidXNlcmlkIjoiNTYyMDE5MDAzNDgzNyJ9.3q8EkUHBa2-KDFwZ86H7l6XPi2GOayiIxwR44Jnbfmg'
    //   }
    // })
    //   .then(res => {
    //    // const position_education = res.data;
    //    // this.setState({ position_education });
    //   })


                  fetch('https://mua.kpru.ac.th/FrontEnd_Mis/employee/procSEmpInfo/'+localStorage.getItem('type2'), {
                  method: 'get',
                  //body: JSON.stringify(user),
                  headers: {

                  }
                  })
                  .then(res => res.json())
                  .then((res) => {
                    this.setState({ emp : res.procSEmpInfo });
                    this.setState({ empidsent : res.procSEmpInfo[0].citizen_id });
                  })
                  .catch(err => {
                  console.log('request failed', err);
                  })


                  setTimeout(() => {
                    this.Searchcoursenosent();
                 }, 500);
  

    // setTimeout(() => {
    //    //ภายใน
    //     Axios.get('https://conference.kpru.ac.th/PHPAPI/selectarticlefaculty.php?faculty='+localStorage.getItem('admin_faculty'))
    //    .then(res => {
    //      console.log(res);
    //    //  this.setState({ bankname: res.data, loading: false })
    //      this.setState({ articlesci1: res.data})
    //    }) 

     

    //  }, 0);
  }


  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`ค้นหา`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon=""
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          ค้นหา
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          ยกเลิก
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <RightCircleOutlined />

    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };



render() {
// console.log(this.state.search1)
// console.log(this.state.search2)
 //console.log(this.state.search3)


 let { sortedInfo, filteredInfo } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};

 const columns = [
 
  {
      title: 'อาจารย์ผู้สอน',
      dataIndex: 'Teacher',
      key: 'Teacher',
      ...this.getColumnSearchProps('Teacher'),
      render: text => <a>{text}</a>,
  },
  {
    title: 'รหัสวิชา',
    dataIndex: 'SJCODE',
    key: 'SJCODE',
    ...this.getColumnSearchProps('SJCODE'),
 
    render: text => <a>{text}</a>,
},
  {
      title: 'ชื่อวิชา(ไทย)',
      dataIndex: 'SUBJNAME',
      key: 'SUBJNAME',
      ...this.getColumnSearchProps('SUBJNAME'),
  render: (text, record) => (<><p>{record.SUBJNAME}{record.SUBJNAME2}</p>
  


    <p>{record.MAJOR.map(c => <div key={c.MAJOR}>- {c.MAJOR}  {c.t_mjname}  {c.faculty_name} {c.NUMREGISTER} คน</div>)}</p> 
   
  
  </> )
     // render: text => <a>{text}</a>,
  },
  {
    title: 'ชื่อวิชา(อังกฤษ)',
    dataIndex: 'ENGNAME1',
    key: 'ENGNAME1',
    render: text => <a>{text}</a>,
},
{
  title: 'คณะ',
  dataIndex: 'Faculty',
  key: 'Faculty',
  render: text => <a>{text}</a>,
},
{
  title: 'หน่วยกิต',
  dataIndex: 'CRHR',
  key: 'CRHR',
  render: text => <a>{text}</a>,
},
{
  title: 'รอบที่',
  dataIndex: 'rob',
  key: 'rob',
 // ...this.getColumnSearchProps('status_name'),
  filters: [
   
    { text: 'รอบ 1', value: '1' },
    { text: 'รอบ 2', value: '2' },
    { text: 'รอบ 3', value: '3' },
    { text: 'รอบ 4', value: '4' },
   
  ],
  onFilter: (value, record) => record.rob.indexOf(value) === 0,

  render: (text, record) => (<>
<p>รอบ{record.rob}</p>
  
  </> )
},

{
  title: 'สถานะ',
  dataIndex: 'status_name',
  key: 'status_name',
 // ...this.getColumnSearchProps('status_name'),
  filters: [
    { text: 'รออาจารย์ผู้สอนดำเนินการ', value: 'อยู่ระหว่างอาจารย์ผู้สอนดำเนินการ' },
    { text: 'รอประธานโปรแกรมดำเนินการ', value: 'อยู่ระหว่างประธานโปรแกรมดำเนินการ' },
    { text: 'รอคณบดีดำเนินการ', value: 'อยู่ระหว่างคณบดีดำเนินการ' },
    { text: 'รอรองอธิการบดีฝ่ายวิชาการดำเนินการ', value: 'อยู่ระหว่างรองอธิการบดีฝ่ายวิชาการดำเนินการ' },
    { text: 'เจ้าหน้าที่คณะพิมพ์เอกสาร', value: 'อยู่ระหว่างเจ้าหน้าที่คณะ พิมพ์เอกสาร' },
    { text: 'เจ้าหน้าที่คณะพิมพ์เอกสารแล้ว', value: 'เจ้าหน้าที่คณะ พิมพ์เอกสารแล้ว' },
    { text: 'ทะเบียนรับเอกสารแล้ว', value: 'ทะเบียนรับเอกสารแล้ว' },
  ],
  onFilter: (value, record) => record.status_name.indexOf(value) === 0,

  render: (text, record) => (<>

   {record.status_code === "4"  ? <> <MDBBtn
        href={record.Url}
        target="_blank"
        color="primary"
        download
      >พิมพ์</MDBBtn>   </> : <> {  record.status_code === "5" ? <><MDBBtn
      href={record.Url}
      target="_blank"
      color="pink"
      download
    >พิมพ์แล้ว <br/> {record.print_date} {record.print_time}</MDBBtn> </> : <><Alert message={record.status_name} type="success" /></> } </>}
  

  </> )
},
  // {
  //     title: 'ตรวจสอบ',
  //     dataIndex: 'Menager',
  //     key: 'Menager',
  //     render: (text, record) => (<Link to={'/components/curriculum/ListMkoYear/'+record.CURR_ID+'/'+this.state.valueselect}>แสดงรายวิชา</Link>),
  // },
];




    return (
        <MDBContainer fluid>
        <div>
           

            {/* <p className="text-right"> (ผู้ดูแลระบบระดับคณะ)</p>
            <p className="text-right">ระบบบริหารจัดการเกรด มหาวิทยาลัยราชภัฏกำแพงเพชร</p> 

            { localStorage.getItem('admin_faculty') == 7 ? <><p className="text-right">มรภ.กพ แม่สอด</p></>:<></>}
            { localStorage.getItem('admin_faculty') == 6 ? <><p className="text-right">คณะพยาบาลศาสตร์</p></>:<></>}
            { localStorage.getItem('admin_faculty') == 5 ? <><p className="text-right">คณะเทคโนโลยีอุตสาหกรรม</p></>:<></>}
            { localStorage.getItem('admin_faculty') == 4 ? <><p className="text-right">คณะวิทยาการจัดการ</p></>:<></>}
            { localStorage.getItem('admin_faculty') == 3 ? <><p className="text-right">คณะมนุษยศาสตร์และสังคมศาสตร์</p></>:<></>}
            { localStorage.getItem('admin_faculty') == 2 ? <><p className="text-right">คณะวิทยาศาสตร์และเทคโนโลยี</p></>:<></>}
            { localStorage.getItem('admin_faculty') == 1 ? <><p className="text-right">คณะครุศาสตร์</p></>:<></>} */}

        
<br/>
            {/* <Alert message={"บทความภายใน สาขาวิทยาศาสตร์และเทคโนโลยี จำนวน "+ this.state.articlesci1.length+" บทความ"} type="info" /> */}
           


  <MDBRow>
    <MDBCol md="2"><Leftmenu/></MDBCol>
    <MDBCol md="10">


    {this.state.coursenosent.length !== 0 ?<>

<Badge count={this.state.coursenosent.length} className='mb-2'>
<Avatar shape="square" size="large">ค้างส่ง</Avatar>
</Badge>
<p >จำนวนวิชายังไม่จัดส่งแต่ละเทอม/ประเภท</p>
<MDBAlert color="danger" >
<MDBTable>
    <MDBTableHead>
        <tr>
        <th>ลำดับ</th>
        <th>ปีการศึกษา</th>
        <th>ประเภท</th>
        <th>จำนวนที่ยังไม่ได้พิมพ์/ส่ง</th>
        <th>จัดการ</th>
        </tr>
    </MDBTableHead>

    <MDBTableBody>
    {this.state.coursenosent.map((coursenosent,index )  => 
        <tr>
        <td>{index+1}</td>
        <td>{coursenosent.termin}</td>
        <td>{coursenosent.type_std_name}</td>
        <td>{coursenosent.row_not_print}  วิชา</td>
        <td><Button  type="primary" onClick={() => this.Searchcoursenosentlist(coursenosent.ki,coursenosent.termin)} >ค้นหา</Button></td>
        </tr>
      )}
    </MDBTableBody>
    </MDBTable>
    </MDBAlert>

</>:<></>}    



    <MDBBreadcrumb light color="bbdefb blue lighten-4">
    <MDBBreadcrumbItem active>ค้นหาผลการเรียนจาก i </MDBBreadcrumbItem>
  </MDBBreadcrumb>
                  <Form>
                <MDBRow>
                  <MDBCol sm="3">
                
                              <Form.Item label="เลือกประเภทนักศึกษา" hasFeedback validateStatus="Success">
                                  <Select defaultValue=""
                                  onSelect={this.onChangeSelect("search1")}
                                  >
                                      <Option value="" hidden>--ประเภทนักศึกษา--</Option>
                                      <Option value="1">ปกติ</Option>
                                      <Option value="2">กศ.บป.(กำแพงเพชร)</Option>
                                      <Option value="3">กศ.บป.(แม่สอด)</Option>
                                      <Option value="4">ป.โท</Option>
                                      <Option value="5">ปกติ (แม่สอด)</Option>
                                      <Option value="6">ป.วิชาชีพครู</Option>
                                      <Option value="7">ป.เอก</Option>
                                  </Select>
                                
                              </Form.Item>
                            
                  </MDBCol>
                  <MDBCol sm="3">
                  <Form.Item label="เลือกภาคการเรียน" hasFeedback validateStatus="Success">
                                  <Select defaultValue=""
                                  onSelect={this.onChangeSelect("search2")}
                                  >
                                      <Option value="" hidden>--ภาคการเรียน--</Option>
                                      <Option value="1">1</Option>
                                      <Option value="2">2</Option>
                                      <Option value="3">3</Option>
                                  </Select>
                                
                              </Form.Item>

                  </MDBCol>
                  <MDBCol sm="3">
                  <Form.Item label="เลือกปีการศึกษา" hasFeedback validateStatus="Success">
                                  <Select defaultValue=""
                                  onSelect={this.onChangeSelect("search3")}
                                  >
                                      <Option value="" hidden>--ปีการศึกษา--</Option>
                                      <Option value="2569">2569</Option>
                                       <Option value="2568">2568</Option>
                                      <Option value="2567">2567</Option>
                                      <Option value="2566">2566</Option>
                                      <Option value="2565">2565</Option>
                                      <Option value="2564">2564</Option>
                                      <Option value="2563">2563</Option>
                                      <Option value="2562">2562</Option>
                                      <Option value="2561">2561</Option>
                                  </Select>
                                
                              </Form.Item>

                  </MDBCol>
                  <MDBCol sm="3"> <Button  type="primary" onClick={this.Search.bind(this)} >ค้นหา</Button> </MDBCol>
                </MDBRow>

                </Form>



                {
                    this.state.Loading===true ? 
                        <><Loading/></> : this.state.curriculamlist.length === 0 ? <div></div>:<Table columns={columns} dataSource={this.state.curriculamlist} onChange={this.handleChange} />
                        
                }   
    </MDBCol>
    
  </MDBRow>

                

        </div>
        </MDBContainer>

    )
}
}
